module.exports = __webpack_public_path__ + "img/point2.8fe208dc.png";